import React from 'react'
import '../css/case-study-details.css'
import MegaMenu from '../components/MegaMenu/MegaMenu'
import Footer from '../components/footer/Footer'
import SoftwareCompanyCta from '../components/software-company-cta/SoftwareCompanyCta'
import { useTranslation } from 'react-i18next'
import ServicesPageBanner from '../components/services-page-banner/ServicesPageBanner'
import NewCaseStudySection from '../components/new-case-study-section/NewCaseStudySection'
import { Link, useParams } from 'react-router-dom'
import { newCaseStudies } from '../data/new-case-study-data'
import Button from '../components/CtaButton'
import SecondCtaBox from '../components/second-cta/SecondCtaBox'
import CoverTheStack from '../components/coverthestack/CoverTheStack'
import { Helmet } from 'react-helmet'
import useIsMobile from '../hooks/useIsMobile'
import { truncateWords } from '../utils/textUtils'

const NewCaseStudyDetails = () => {

    // SHOW CASE STUDY DETAILS
    const { slug } = useParams();
    const caseStudy = newCaseStudies.find(cs => cs.slug === slug);

    const isMobile = useIsMobile()


    return (
        <>
            <Helmet>
                <title>Digital Innovation and Transformation Success Stories | Bitsclan</title>
                <meta name="description" content="Have a look at the highlights of our AI, ecommerce, custom software and mobile app development success stories, and see why our clients love our work. We have delivered successful projects for many brands." />
            </Helmet>

            <MegaMenu />

            <div
                className="featured-case-study-card case-study-details-banner-image"
                style={{ backgroundImage: `url(${caseStudy?.mainImage})` }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {caseStudy?.productLogo && <div className="case-study-detail-banner-tag mb-4"><img src={caseStudy?.productLogo} alt="case study logo" /></div>}
                            <h2 className='low-top-heading text-white position-relative mt-1'>{caseStudy?.shortHeading}</h2>
                            <p className='case-study-detail-banner-main-heading'>{caseStudy?.mainHeading}</p>
                            <p dangerouslySetInnerHTML={{
                                __html: isMobile ? truncateWords(caseStudy?.mainDescription, 10) : caseStudy?.mainDescription,
                            }}></p>

                            <div className="stats">
                                {caseStudy?.mainStats?.map((item, index) => {
                                    return <div className="stat-item" key={index}>
                                        <h3>{item?.value}</h3>
                                        <p>{item?.text}</p>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CASE STUDY DETAILS */}


            {/* ABOUT SECTION */}
            <section className="case-study-details-about-section pb-0">
                <div className="container">
                    <div className="row g-0">
                        <div className="col-lg-12 case-study-details-about-section-left">
                            <h2 className='low-top-heading'>{caseStudy?.aboutSection?.shortHeading}</h2>
                            <p className="case-study-details-about-section-heading mb-2">{caseStudy?.aboutSection?.aboutHeading}</p>
                            <p className="case-study-details-about-section-sub-heading">{caseStudy?.aboutSection?.aboutDescription}</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* ABOUT SECTION */}

            {/* CATEGORY SECTION */}
            <section className="case-study-details-category-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="case-study-details-category-left">
                                <div className="case-study-details-category-left-image-container">
                                    <img src={caseStudy?.aboutSection?.industryImage} alt="Industry Image" />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="case-study-details-category-right container">
                                <div className="case-study-details-category-column row">
                                    <div className="info-content case-study-details-category-item col-md-6">
                                        <div className="case-study-details-category-label">Industry</div>
                                        {caseStudy?.aboutSection?.industry?.map((list, index) => {
                                            return <span className='info-badge' key={index}>{list}</span>
                                        })}
                                    </div>

                                    <div className="info-content case-study-details-category-item col-md-6">
                                        <div className="case-study-details-category-label">Business Type</div>
                                        <span className='info-badge'>{caseStudy?.aboutSection?.businessType}</span>
                                    </div>

                                    <div className="case-study-details-category-item col-md-12">
                                        <div className="case-study-details-category-label">Services</div>
                                        <div className="info-content case-study-details-category-value">
                                            {caseStudy?.aboutSection?.services?.map((service, index) => (
                                                <span key={index} className="info-badge">
                                                    {service}
                                                    {/* {index < caseStudy.aboutSection.services.length - 1 && ", "} */}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="case-study-details-category-column row">
                                    {caseStudy?.aboutSection?.modulesDeveloped && <div className="case-study-details-category-item col-md-12">
                                        <div className="case-study-details-category-label">Modules Developed</div>
                                        <div className="case-study-details-category-value">
                                            <div className='info-content'>
                                                {caseStudy?.aboutSection?.modulesDeveloped?.map((list, index) => {
                                                    return <span className='info-badge' key={index} dangerouslySetInnerHTML={{ __html: list }}></span>
                                                })}
                                            </div>
                                        </div>
                                    </div>}

                                    <div className="col-md-12">
                                        <div className="case-study-details-industry-show-button">
                                            <Button text={caseStudy?.aboutSection?.cta?.text} link={caseStudy?.aboutSection?.cta?.link}></Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* CATEGORY SECTION */}

            {/* BUSSINESS CHALANGES */}
            {caseStudy?.bussinessChallengeSection && <div className="bussiness-chalanges-main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6">
                            <div className="bussiness-chalanges-section-conent">
                                <h4>{caseStudy?.bussinessChallengeSection?.mainHeading}</h4>
                                <p className="description-text">{caseStudy?.bussinessChallengeSection?.description}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            {caseStudy?.bussinessChallengeSection?.challengePoints?.map((item, index) => {
                                return <div className="bussiness-chalanges-content-box" key={index}>
                                    <h4>{item?.title}</h4>
                                    <p className="description-text">{item?.description}</p>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>}
            {/* BUSSINESS CHALANGES */}

            {/* CASE STIDY OUR GOLAS SECTION */}
            <section className="case-study-details-our-goals-section">
                <div className="container">
                    <h2 className="case-study-details-heading ">{caseStudy?.challengesSection?.heading}</h2>
                    <p className="description-text text-white mb-5">{caseStudy?.challengesSection?.description}</p>

                    <div className="row align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="row">
                                {caseStudy?.challengesSection?.challengePoints?.slice(0, 3)?.map((list, index) => {
                                    return <div className="col-12">
                                        <div className="case-study-details-goal-item" key={index}>
                                            <h3 className="case-study-details-number">{index + 1}</h3>
                                            <div className="case-study-details-content">
                                                <h4 className="case-study-details-title">{list?.title}</h4>
                                                <p className="case-study-details-description">{list?.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-4 d-flex justify-content-center my-4 my-md-0">
                            <img src={caseStudy?.challengesSection?.chanllengeImage} className="img-fluid" alt="Our Challenges" />
                        </div> */}
                        <div className="col-12 col-md-6">
                            <div className="row">
                                {caseStudy?.challengesSection?.challengePoints?.slice(3, 6)?.map((list, index) => {
                                    return <div className="col-12">
                                        <div className="case-study-details-goal-item" key={index}>
                                            <h3 className="case-study-details-number">{index + 4}</h3>
                                            <div className="case-study-details-content">
                                                <h4 className="case-study-details-title">{list?.title}</h4>
                                                <p className="case-study-details-description">{list?.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* CASE STIDY OUR GOLAS SECTION */}

            {/* SOLUTION SECTION */}
            <section className="case-study-solutions">
                <div className="container">
                    <div className="row">
                        {/* Left Content */}
                        <div className="col-md-12">
                            <h2 className="case-study-solutions-heading">{caseStudy?.solutionsSection?.heading}</h2>
                        </div>

                        <div className="col-xl-7 col-lg-7 col-md-12">
                            <div className="case-study-solution-main-box">
                                <ul className="case-study-solutions-list list-unstyled mt-4">
                                    {caseStudy?.solutionsSection?.solutionPoints?.map((list, index) => {
                                        return <li key={index}>
                                            <span className="case-study-solutions-number">{list?.number}</span>
                                            <span className="case-study-solutions-text" dangerouslySetInnerHTML={{
                                                __html: list?.text,
                                            }}></span>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                        {/* Right Image */}
                        <div className="col-xl-5 col-lg-5 col-md-12 text-center">
                            <img src={caseStudy?.solutionsSection?.solutionImage} alt="case-study" className="case-study-solutions-img" />
                        </div>
                    </div>
                </div>
            </section>
            {/* SOLUTION SECTION */}

            {/* CLIENT REVIEW BOX */}
            <div className="content-side-box-together">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-5">
                            <div className="company-logo-image">
                                <img src="/images/SVG/FeteTICKETS.svg" alt="Profile" />
                            </div>
                        </div>

                        <div className="col-xl-9 col-lg-9 col-md-7">
                            <div className="comapny-together-content">
                                <p>{caseStudy?.testimonialContent?.content || `Thanks to Bitsclan's expertise, we achieved faster order processing, seamless coordination, & a scalable shipping ecosystem making cross-border logistics simpler & more reliable for our customers.`}</p>
                            </div>

                            <div className="company-text-owner">
                                <h4>{caseStudy?.testimonialContent?.autherName || `Kemar Campbell`}</h4>
                                <p>{caseStudy?.testimonialContent?.autherDesignation || `Managing Director of AirDrop Limited & AirDrop Logistics LLC Jamaica`}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* CLIENT REVIEW BOX */}

            {/* THE RESULTS SECTION */}
            <section className="results-section">
                <div className="container">
                    <h2 className="low-top-heading text-center">{caseStudy?.resultsSection?.shortHeading}</h2>
                    <p className='results-title'>{caseStudy?.resultsSection?.heading}</p>
                    <p className="description-text text-center">{caseStudy?.resultsSection?.description}</p>
                    <div className="row justify-content-center">
                        {caseStudy?.resultsSection?.resultStats?.map((list, index) => {
                            return <div className="col-md-4 col-sm-6 col-6 results-box" key={index}>
                                <div className="results-number"><h4>{list?.value}</h4> {list?.up && <span><i className="fa-solid fa-arrow-up"></i></span>}</div>
                                <p className="results-text">{list?.text}</p>
                            </div>
                        })}
                    </div>
                </div>
            </section>

            <SecondCtaBox content={caseStudy?.ctaSection1} />

            {/* THE RESULTS SECTION */}

            {/* OUR CHALLANGE */}
            {/* <section className="case-study-details-our-challange-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 d-flex justify-content-center">
                            <div className="case-study-details-image-wrapper">
                                <div className="case-study-details-chalange-image">
                                    <img src="/images/case-studies/ai-self-study.avif" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex align-items-center justify-content-center justify-content-lg-start">
                            <div className="case-study-details-text-content">
                                <div className="case-study-details-number">1</div>
                                <p className="case-study-details-text">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea, veniam nostrum. Dignissimos ducimus, fugiat animi voluptatum magni voluptas delectus corrupti, architecto nostrum doloremque officiis iste itaque quidem possimus, ea quo laudantium cum aliquid. Sed ipsum nesciunt aspernatur dolorem omnis aliquam aut. Sapiente ad modi neque ea doloremque corrupti adipisci soluta?
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}


            {/* OUR SOLUTION */}
            {/* <div className="our-solution-main">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-5 col-md-12">
                            <div className="our-soluton-text">
                                <h4>Our Solution</h4>

                                <p className='common-text'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa eligendi aliquam repellendus. Id culpa illum tempora sequi. Quo praesentium dolor labore aspernatur natus molestiae laboriosam mollitia fugiat obcaecati fuga, odio nobis facere repudiandae voluptas deserunt iste dolorum in ipsam temporibus delectus reprehenderit provident. Aliquid repellendus reprehenderit, quo culpa error beatae.</p>
                            </div>
                        </div>

                        <div className="col-md-2 none-tab-show">
                            <div className="line-image-solution"></div>
                        </div>

                        <div className="col-xl-5 col-lg-5 col-md-12">
                            <div className="solution-text-main">
                                <h3>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, amet.</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* CASE STUDY DETAILS */}

            <CoverTheStack
                whereStart={caseStudy?.techStack?.whereStarts || "Custom Software Technologies"}
                shortHeading={"Technology Stack"}
                mainHeading={"Enterprise-Grade Technology Stack"}
                subHeading={
                    "We leverage a proven technology stack to design secure, scalable, & high-performing solutions. By combining modern frameworks, databases, & cloud services, we ensure every product we build is reliable, efficient, & future-ready."
                }
                tabs={caseStudy?.techStack?.tabs}
                tabItems={caseStudy?.techStack?.tabItems}
            />

            {/* <NewCaseStudySection
                shortHeading="Lorem ipsum dolor sit"
                heading="Lorem ipsum dolor sit, amet consectetur."
                description="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Esse recusandae quasi inventore temporibus dolor laudantium reiciendis explicabo asperiores nulla at." /> */}

            <SoftwareCompanyCta content={caseStudy?.ctaSection2} />
            <Footer />
        </>
    )
}

export default NewCaseStudyDetails